import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Controller } from 'react-hook-form';
import { cn } from '../../lib/utils'
import PropTypes from 'prop-types';

const SearchableSelectInput = ({ onValueChange, value, options = [], rules, errors, placeholder, className, name = '', control, label, required, defaultValue, readOnly, errorShow = true, disabled }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])
    
    useEffect(() => {
    if(options.length > 0){
        setFilteredOptions(options)
    }
    }, [options.length])

    useEffect(() => {
        if (typeof value === 'string') {
            onValueChange(options?.find(option => option?.label?.toLowerCase() === value?.toLowerCase())?.value || value, name)
        }
    }, [value])

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setShowDropdown(true);
        const filtered = options.filter(option => option.label.toLowerCase().includes(newValue.toLowerCase()));
        setFilteredOptions(filtered);
        onValueChange(options?.find(option => option.label.toLowerCase() === newValue.toLowerCase())?.value || newValue, name);
    };

    const handleSelect = (selectedValue) => {
        setShowDropdown(false);
        if (onValueChange) {
            onValueChange(selectedValue.value, name);
        }
    };
        
    return (
        <Fragment>
            {label && <label className={cn('grc-label block mb-1')}>{label}{required && <span className='text-danger'>*</span>}</label>}
            <div className="relative" ref={dropdownRef}>
                <Controller
                    defaultValue={defaultValue}
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field: { onChange } }) => (
                        <div className="relative">
                            <input
                                type="text"
                                disabled={disabled}
                                className={cn(
                                    'input-grc flex h-9 w-[95%] rounded-lg ring-[1.5px] ring-[hsl(var(--border))] border-none bg-transparent px-3 py-3 text-sm shadow-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
                                    readOnly && 'bg-popover',
                                    className
                                )}
                                placeholder={placeholder}
                                value={typeof value === 'number' ? options?.find((findData) => findData?.value === value)?.label : value?.label || value}
                                onKeyDown={(elKey) => {
                                    if (elKey.key === 'Tab') {
                                        setShowDropdown(false)
                                    }
                                }}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    onChange(e.target.value);
                                }}
                                onClick={() => setShowDropdown(!showDropdown)}
                                readOnly={readOnly}
                            />
                            {showDropdown && filteredOptions.length > 0 && (
                            <div
                                style={{ backgroundColor: '#fff', maxHeight: '150px', overflowY: 'auto' }}
                                className="absolute z-10 w-full border border-primary rounded-md py-2 mt-1">
                                {filteredOptions.map((option, index) => ( 
                                    <div
                                    className="cursor-pointer px-3 text-muted py-2 hover:bg-popover"
                                    onClick={() => { 
                                        onChange(option.value)
                                        handleSelect(option) 
                                    }
                                    }> {option.label}
                                     </div>
                                ))}
                            </div>
                            )}
                        </div>
                    )}
                />
                {errors && name && errors[name] && <p className='grc-error-msg text-danger'>{errors && name && errors[name]?.message}</p>}
            </div>
        </Fragment>
    );
};

SearchableSelectInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.any,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    required: PropTypes.bool,
    options: PropTypes.array,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errorShow: PropTypes.bool,
    readOnly: PropTypes.bool,
};

SearchableSelectInput.defaultProps = {
    readOnly: false,
};

export default SearchableSelectInput;